export default "__VITE_ASSET__DkAYHXeA__"